import { PAGE_SIZE } from "shared/const"
import { CompaniesListReq, CorporateListRequest, MatchListReq, MessagesListReq, Pager, PaginatedRequest, StartupsListReq } from "./Api"
import { MatchStatus } from "./Context"
import { initalStartUp, initialCorporate, initialStartUpInfo, Match } from "./types"

export const initialPager: Pager = {
    totalItems: 0,
    pageNum: 0,
    pageSize: 10,
    totalPages: 0,
    startPage: 0,
    endPage: 0
}

export const initialServiceReq: PaginatedRequest = {
    pageNum: 0,
    pageSize: 10,
    orderBy: "",
    orderDirection: 'desc',
}

export const initialReqCorporate: CompaniesListReq = {
    pageNum: 0,
    pageSize: 10,
    orderBy: "",
    orderDirection: 'desc',
    departments:[],
    levels:[],
    tags:[],
    sectors:[]
}

export const initialReqStartup: StartupsListReq = {
    pageNum: 0,
    pageSize: 10,
    orderBy: "",
    orderDirection: 'desc',
    tags: [],
    sectors: [],
    constitutionStatuses: []
}

export const initialReqMatchList : MatchListReq ={
    pageNum: 0,
    pageSize: PAGE_SIZE.matchList,
    orderBy: "",
    orderDirection: 'asc',
    searchText: ""
}

export const  initialReqMessagesList: MessagesListReq ={
    pageNum: 0,
    pageSize: 10,
    orderBy: "",
    orderDirection: 'asc',
    matchId: ""
}

export const initialMatchSeleceted:Match = {
    id: "",
    status: MatchStatus.StartupRefusedMatch,
    company: initialCorporate,
    startup: initalStartUp,
    lastMessageDate: "",
    isReadCompany:false,
    isReadStartup:false
}

